var React = require('react');

function IconArrowRight2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"arrow-right-2"},React.createElement("path",{"id":"vector","fillRule":"evenodd","clipRule":"evenodd","d":"M13.2458 7.08744C13.4736 7.31525 13.4736 7.68459 13.2458 7.9124L9.16249 11.9957C8.93468 12.2235 8.56534 12.2235 8.33753 11.9957C8.10973 11.7679 8.10973 11.3986 8.33753 11.1708L11.4251 8.08325H1.16668C0.844511 8.08325 0.583344 7.82208 0.583344 7.49992C0.583344 7.17775 0.844511 6.91659 1.16668 6.91659H11.4251L8.33753 3.82906C8.10973 3.60126 8.10973 3.23191 8.33753 3.00411C8.56534 2.7763 8.93468 2.7763 9.16249 3.00411L13.2458 7.08744Z","fill":"currentColor","fillOpacity":"1"})));
}

IconArrowRight2.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 14 15","fill":"none"};

module.exports = IconArrowRight2;

IconArrowRight2.default = IconArrowRight2;
